// extracted by mini-css-extract-plugin
export default {"header":"mJ","light":"nJ","dark":"oJ","headertitle":"pJ","fname":"qJ","headerContent":"rJ","right":"sJ","descriptionwrapper":"tJ","appear":"uJ","second":"vJ","third":"wJ","forth":"xJ"};
    if(module.hot) {
      // 1714422957561
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  